<template>
    <div class="sidebar-detail">
        <detail-header
            v-if="detailInfo"
            title="Germination Batch"
            @refreshDetailPage="refreshDetailPage"
            @closeDetailPage="closeDetailPage"
        />

        <div v-if="detailInfo">
            <p class="detail-title">Details</p>
            <el-steps class="stepper-container" :active="highlightedStep" align-center finish-status="success">
                <el-step v-for="(step, index) in steps" :key="'step' + index" :title="step.name" :description="step.description" />
            </el-steps>

            <div>
                <table class="recording-detail-table">
                    <tr>
                        <td>Id</td>
                        <td>{{ detailInfo.id }}</td>
                    </tr>
                    <!-- <tr>
                        <td>QR Code</td>
                        <td>{{ qrCode }}</td>
                    </tr> -->
                    <tr>
                        <td>Batch Name</td>
                        <td>{{ detailInfo.batchName }}</td>
                    </tr>
                    <tr>
                        <td>Batch Number</td>
                        <td>{{ detailInfo.batchNo }}</td>
                    </tr>
                    <tr>
                        <td>Germinated Seed Bag Count</td>
                        <td>{{ detailInfo.germinatedSeedBags.length }}</td>
                    </tr>
                    <tr>
                        <td>Germinated Start Date</td>
                        <td>{{ this.$_getMyrDateFormat(detailInfo.germinationStartDate) }}</td>
                    </tr>
                    <tr>
                        <td>Germinated End Date</td>
                        <td>{{ this.$_getMyrDateFormat(detailInfo.germinationEndDate) }}</td>
                    </tr>
                </table>
            </div>

            <p class="detail-title detail-title-pd">Germination Batch Transaction</p>
            <germination-batch-transaction-simple-table :batch-id="detailInfo.id" />

            <p class="detail-title detail-title-pd">Germination Batch Progeny</p>
            <germination-batch-progeny-simple-table :progeny-list="detailInfo.progenies" />

            <p class="detail-title detail-title-pd">Germination Batch Program</p>
            <germination-batch-program-simple-table :program-list="detailInfo.programs" />

            <p class="detail-title detail-title-pd">Date Time</p>
            <div class="user-datetime-container">
                <table>
                    <tr>
                        <td>Modified</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.lastModificationTime) }} {{ $t('detail.by') }} {{ (detailInfo.lastModifierUser||{}).userName || '-' }}</td>
                    </tr>
                    <tr>
                        <td>Created</td>
                        <td>{{ $_getDateTimeFormat(detailInfo.creationTime) }} {{ $t('detail.by') }} {{ (detailInfo.creatorUser||{}).userName || '-' }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import DetailHeader from "./DetailHeader";
import { germinationBatchGet } from "@/api/germination_batch";
import GerminationBatchTransactionSimpleTable from "@/components/GerminationBatchTransaction/GerminationBatchTransactionSimpleTable";
import GerminationBatchProgenySimpleTable from "@/components/GerminationBatch/GerminationBatchProgenySimpleTable";
import GerminationBatchProgramSimpleTable from "@/components/GerminationBatch/GerminationBatchProgramSimpleTable";

export default {
    components: {
        "detail-header": DetailHeader,
        "germination-batch-transaction-simple-table": GerminationBatchTransactionSimpleTable,
        "germination-batch-progeny-simple-table": GerminationBatchProgenySimpleTable,
        "germination-batch-program-simple-table": GerminationBatchProgramSimpleTable,
    },
    props: {
        infoSidebarId: {
            type: Number | String
        }
    },
    data() {
        return {
            detailInfo: null,
            detailSteps: [
                { name: "MC 1", dateKey: "moistureContent1TestDate" },
                { name: "Soak In 1", dateKey: "soakInDate1" },
                { name: "Soak Out 1", dateKey: "soakOutDate1" },
                { name: "Heat In", dateKey: "heatInDate" },
                { name: "Heat Out", dateKey: "heatOutDate" },
                { name: "Soak In 2", dateKey: "soakInDate2" },
                { name: "Soak Out 2", dateKey: "soakOutDate2" },
                { name: "MC 2", dateKey: "moistureContent2TestDate" },
            ]
        };
    },
    computed: {
        qrCode() {
            return this.detailInfo.qrCode ? `${this.detailInfo?.qrCode?.code}` : "";
        },
        expireDate() {
            if (this.detailInfo.expireDate) {
                let days = this.$_getDaysFromDate(this.detailInfo.expireDate);
                let format_date = this.$_getMyrDateFormat(this.detailInfo.expireDate);
                return `${format_date} (${days})`;
            }
            else return "-";
        },
        steps() {
            return this.detailSteps.map(step => ({
                "name": step.name,
                "description": this.getRecordDate(this.detailInfo[step.dateKey]),
                "value": this.getIsHavingRecord(this.detailInfo[step.dateKey])
            }));
        },
        highlightedStep() {
            let lastHighlightedIndex = -1;
            this.steps.forEach((step, index) => {
                if (step.value === true) {
                    lastHighlightedIndex = index;
                }
            });
            return lastHighlightedIndex == -1 ? 0 : lastHighlightedIndex + 1;
        }
    },
    watch: {
        infoSidebarId: {
            immediate: true,
            handler() {
                this.getDetails();
            },
        }
    },
    methods: {
        async getDetails() {
            if (this.infoSidebarId) {
                var res = await germinationBatchGet({ Id: this.infoSidebarId });
                if (res) {
                    this.detailInfo = res;
                }
            }
        },
        getRecordDate(recordDate) {
            let date = this.$_getMyrDateFormat(recordDate);
            return `${date}`;
        },
        getIsHavingRecord(recordDate) {
            if (recordDate) {
                return true;
            }
            else return false;
        },
        refreshDetailPage() {
            this.getDetails();
        },
        closeDetailPage() {
            this.$store.dispatch("info_sidebar/setInfoSidebar");
        }
    }
};
</script>

<style scoped>
.stepper-container {
    padding: var(--space-12) 0;
    margin-bottom: var(--space-12);
    width: 360px;
    overflow-x: scroll;
}
</style>


// WEBPACK FOOTER //
// src/components/SidebarDetail/FreshSeedBatchingSidebar.vue